const fontFamily = {
  fontPrimary: 'Inter',
  fontSecondary: 'Montserrat',
};

const typography = {
  fontPrimary: `${fontFamily.fontPrimary}, sans-serif`,
  fontSecondary: `${fontFamily.fontSecondary}, sans-serif`,
};

export default typography;
